import PropTypes from 'prop-types';

import { EmailsSelect } from './Dropdown';
import styles from './styles.module.scss';

RSelectEmail.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  currentEmail: PropTypes.string,
  inputClassNames: PropTypes.string,
  containerClassNames: PropTypes.string,
  placeholder: PropTypes.string,
  arrMails: PropTypes.arrayOf(PropTypes.string),
  isOpenSelects: PropTypes.bool,
  setEmail: PropTypes.func,
  register: PropTypes.func,
};

export function RSelectEmail({
  type = 'text',
  name = 'email',
  currentEmail,
  inputClassNames,
  containerClassNames,
  placeholder,
  arrMails,
  isOpenSelects,
  setEmail,
  register,
  ...restInputProps
}) {
  return (
    <div className={`${styles.container} ${containerClassNames}`}>
      <EmailsSelect
        currentEmail={currentEmail}
        isOpenSelects={isOpenSelects}
        arrMails={arrMails}
        setEmail={setEmail}
      >
        <>
          <input
            type={type}
            name={name}
            className={`input-field ${inputClassNames}`}
            autoComplete="off"
            placeholder={placeholder}
            {...restInputProps}
            {...register(name)}
          />

          <span className="icon-success">
            <i className="fas fa-check txt-c-green" />
          </span>
        </>
      </EmailsSelect>
    </div>
  );
}
